module.exports = __webpack_public_path__ + "static/img/wh-103.6c53f7af.png";